<template>
  <el-main class="invoice">
    <el-dialog title="手动填写数据"
               :visible.sync="manualShow"
               width="500px">
      <el-form :model="manualDate"
               ref="manualDate"
               label-width="100px">
        <el-form-item label="包裹数量"
                      prop="number"
                      :rules="[
      { required: true, message: '数量不能为空'},
      { type: 'number', message: '数量必须为数字值'}
    ]">
          <el-input-number v-model="manualDate.number"
                           :min="1"
                           :max="100"
                           label="订单包裹一共多少"></el-input-number>
        </el-form-item>

        <el-form-item label="主单号"
                      prop="masterNumber"
                      :rules="[
      { required: true, message: '主单号不能为空'}
    ]">
          <el-input v-model="manualDate.masterNumber"
                    placeholder="请输入主单号"></el-input>
        </el-form-item>

        <el-form-item label="收件人姓名"
                      prop="recipients"
                      :rules="[
      { required: true, message: '收件人姓名不能为空'}
    ]">
          <el-input v-model="manualDate.recipients"
                    placeholder="请输入收件人姓名"></el-input>
        </el-form-item>

        <el-form-item label="联系方式"
                      prop="recipients"
                      :rules="[
      { required: true, message: '收件人手机号码不能为空'}
    ]">
          <el-input v-model="manualDate.mobile"
                    placeholder="请输入收件人手机号码"></el-input>
        </el-form-item>

        <el-form-item label="收件人地址"
                      prop="recipients"
                      :rules="[
      { required: true, message: '收件人地址不能为空'}
    ]">
          <el-input v-model="manualDate.site"
                    placeholder="请输入收件人地址"></el-input>
        </el-form-item>

        <el-form-item label="寄往国家"
                      prop="recipients"
                      :rules="[
      { required: true, message: '寄往国家不能为空'}
    ]">
          <el-input v-model="manualDate.state"
                    placeholder="请输入寄往国家"></el-input>
        </el-form-item>

      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="manualShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="generateDate('manualDate')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 控制发票 -->
    <div class="invoice_control"
         v-if="active_state===''">
      <!-- 提示文字 -->
      <div class="invoice_control_title">
        <ul>
          <li>1. 提示文字在这里显示</li>
          <li>2. 可以在这里添加一些教程</li>
          <li>3. 暂时不做这些内容</li>
          <li>4. 先随便写点东西来看看样式效果</li>
        </ul>
      </div>
      <!-- 操作按钮 -->
      <div class="invoice_control_button">
        <el-button type="primary"
                   icon="el-icon-printer"
                   @click="printExpressWaybill()">面单浏览</el-button>
        <el-button type="danger"
                   icon="el-icon-printer"
                   @click="printInvoice()">发票浏览</el-button>
        <el-button type="primary"
                   icon="el-icon-printer"
                   @click="printPickingList()">拣货单</el-button>
        <el-button type="primary"
                   icon="el-icon-printer"
                   @click="printReturnGoods()"
                   :disabled='disabledReuter'>退货单</el-button>
      </div>
      <!-- 发票物品 -->
      <el-collapse v-model="activeName"
                   v-if="!manual"
                   class="invoice_control_set">
        <el-collapse-item :title='"第"+item+"箱"'
                          :name="item"
                          v-for="item in data.bgnum "
                          :key='item.id'>
          <el-table :data="tableData[parseInt(item)-1]"
                    style="width: 100%"
                    class="invoice_control_set_goods"
                    @select='(selection, row)=>tableSelect(selection, row,item)'>
            <el-table-column prop="date"
                             label="显示"
                             width="50"
                             type='selection'>
            </el-table-column>
            <el-table-column label="品名"
                             width="80">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name">{{scope.row.name}}</el-input>
              </template>
            </el-table-column>

            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input type="number"
                          @input="getAmount(parseInt(item)-1)"
                          v-model="scope.row.num"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="unitprice"
                             label="单价">
              <template slot-scope="scope">
                <el-input type="number"
                          @input="getAmount(parseInt(item)-1)"
                          v-model="scope.row.unitprice"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="货币">
              <template slot-scope="scope">
                <el-select v-model="currencty[parseInt(item)-1]"
                           placeholder="请选择"
                           :value-key='scope.row.id'
                           @change='i=>getCurrencty(i,item)'>
                  <el-option v-for="(item,key, i) in currenctyDate"
                             :key="i"
                             :label="key"
                             :value="item">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <div v-else>
        <el-button @click='manualShow=true'>修改信息</el-button>
      </div>
    </div>
    <!-- 浏览发票 -->
    <div class="invoice_show"
         v-loading="loading">
      <!-- 打包票单 -->
      <div class="invoice_express_sheet piaodang"
           v-if="active_state=='pack'&&!manual">
        <!-- 票单标题 -->
        <div class="express_sheet_title"
             style="background-color:#409eff">
          <h3>票单列表</h3>
          <p>*打印浏览时请注意查看是否具有条码显示,如没有显示请重新刷新页面</p>
        </div>
        <div class="sheet_content">
          <!-- 票单内容 -->
          <ul class="express_sheet_content"
              id="printJS-form"
              ref='print'>
            <li class="express_sheet_content_item"
                v-for="item in parseInt(this.$route.query.bgnum) "
                :key="item"
                style="page-break-after:always">
              <div class="print_area"
                   style="display:flex;justify-content: center;">
                <div class="bar_code">
                  <svg class="content_item_code"
                       :id="'barcode'+item">{{barcode('#barcode'+item,$route.query.id+'-'+item,'top',3)}}</svg>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <el-button class='printBotton'
                   size="mini"
                   v-print="printObj">打印</el-button>
      </div>
      <!-- 退货单 -->
      <div class="invoice_express_sheet returnGoods"
           v-if="showReturnGoods&&!manual">
        <!-- 退货单标题 -->
        <div class="express_sheet_title"
             style="background-color:#409eff">
          <h3>退货单列表</h3>
          <p>*打印浏览时请注意查看是否具有条码显示,如没有显示请重新刷新页面</p>
        </div>
        <div class="sheet_content">
          <!-- 票单内容 -->
          <ul class="express_sheet_content"
              id="printJS-form"
              ref='print'>
            <li class="express_sheet_content_item"
                v-for="(item, index) in tuiheinfo"
                :key="index"
                style="page-break-after:always">
              <div class="print_area"
                   style="display:flex;justify-content: center;">
                <div class="returnGoods_view">
                  <div class="returnGoods_title">
                    <span>退货单</span>
                  </div>
                  <div class="returnGoods_info">
                    <div class="returnGoods_info_item">
                      <span class="taxon">订单ID : </span>
                      <span class="taxon_info">{{item.orderid}}</span>
                    </div>
                    <div class="returnGoods_info_item"
                         v-if="item.wpname">
                      <span class="taxon">退货物品名 : </span>
                      <span class="taxon_info"
                            v-for="(item_1,index_1) in item.wpname"
                            :key="index_1"> {{ item_1 }} </span>
                    </div>
                    <div class="returnGoods_info_item letts">
                      <span class="taxon">退货类型 : </span>
                      <span class="taxon_info">{{thtype.type}}</span>
                      <span class="taxon">物品种类 : </span>
                      <span class="taxon_info">{{thtype.total}}</span>
                    </div>
                    <div class="returnGoods_info_item letts">
                      <span class="taxon">退货联系人 : </span>
                      <span class="taxon_info">{{item.sjname}}</span>

                      <span class="taxon">联系方式 : </span>
                      <span class="taxon_info">{{item.sjmobile}}</span>
                    </div>

                    <div class="returnGoods_info_item">
                      <span class="taxon">退货地址 : </span>
                      <span class="taxon_info">{{item.sjgjid+item.sjaddress}}</span>
                    </div>
                  </div>
                  <div class="bar_code">
                    <svg class="content_item_code"
                         :id="'barcode'+item.thcode">{{barcode('#barcode'+item.thcode,item.thcode,'margin-bottom',3,100)}}</svg>
                  </div>
                </div>

              </div>
            </li>
          </ul>
        </div>

        <el-button class='printBotton'
                   size="mini"
                   v-print="printObj">打印</el-button>
      </div>
      <!-- 面单 -->
      <div class="invoice_express_sheet"
           v-if="expressWaybill">
        <!-- 面单标题 -->
        <div class="express_sheet_title"
             style="background-color:#409eff">
          <h3>面单列表</h3>
          <p>*打印浏览时请注意查看是否具有条码显示,如没有显示请重新刷新页面,重新点击浏览</p>
        </div>
        <div class="sheet_content">
          <!-- 面单内容 -->
          <ul class="express_sheet_content"
              id="printJS-form"
              ref='print'>
            <li class="express_sheet_content_item"
                v-for="item in data.bgnum"
                :key="item"
                style="page-break-after:always">
              <div class="print_area">
                <div class="sheet_content_item_top">
                  <div class="company_name">
                    <p style="font-size: 30px;font-size:width:6px;">团运国际</p>
                  </div>
                  <div class="bar_code">
                    <svg class="content_item_code"
                         :id="'barcode'+item">{{test(item,'#barcode')}}</svg>
                  </div>
                </div>
                <div class="sheet_content_item_main">
                  <div class="recipients">
                    <div class="recipients_name">
                      <span class="issue">收件人:</span>{{data.sjname}}
                    </div>
                    <div class="recipients_mobile">
                      <span class="issue">电话:</span>{{data.sjmobile}}
                    </div>
                  </div>
                  <div class="site">
                    <span class="issue">地址: </span>{{manual?data.sjaddress:data.gjname+data.sjprovince+data.sjaddress}}
                  </div>
                  <div class="remark">
                    <span class="issue">主单号:</span> {{data.wlnum}}
                  </div>
                </div>
                <!-- 国家和当前包裹箱号 -->
                <div class="state_num">
                  <div class="state">{{data.sjprovince?data.sjprovince:data.gjname}}</div>
                  <div class="parcel_number">
                    {{`${data.bgnum}/${item}`}}
                  </div>
                </div>
                <div class="sheet_content_item_bottom">
                  <svg class="code_bottom"
                       :id="'code_bottom'+item">{{test(item,'#code_bottom','','')}}</svg>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <el-button class='printBotton'
                   size="mini"
                   v-print="printObj">打印</el-button>
      </div>
      <!-- 发票 -->
      <div class="invoice_express_sheet"
           v-if="invoice&&!manual">
        <div class="express_sheet_title">
          <h3>发票列表</h3>
          <p>*打印发票的时候请确定每一箱的物品,并在左侧选择对应物品</p>
        </div>
        <div class="sheet_content">
          <!-- 发票内容 -->
          <ul class="express_sheet_content"
              id="printJS-form"
              ref='print'>
            <li class="express_sheet_content_item"
                v-for="(item,index) in data.bgnum"
                :key="item"
                style="page-break-after:always">
              <div class="print_area">
                <!-- 发票头部 -->
                <div class="sheet_content_item_top">
                  <div class="invoice_top">
                    <div class="invoice_title">INVOICE</div>
                    <div class="sold_to">
                      <span>SOLD TO:</span>
                      <span>{{data.gjname!=""?(data.gjname+' '+data.sjcity):data.sjcity+' '+data.sjdistrict}}</span>
                    </div>
                  </div>
                </div>
                <div class="sheet_content_item_main invoice_main">
                  <div class="no">
                    <span>NO:</span>
                    <span>{{data.xz_weight_tj==''||data.bgnum==1?data.wlnum:data.xz_weight_tj[index].zdnum}}</span>
                  </div>
                  <el-table :data="newTableData[index]"
                            style="width: 100%"
                            formatter="fmtLength">
                    <template slot="empty">
                      <div class="noCart">
                        Data is empty
                      </div>
                    </template>
                    <el-table-column prop="name"
                                     label="DESCRIPTION"
                                     width="200">
                    </el-table-column>
                    <el-table-column prop="num"
                                     label="QUANTITY">
                    </el-table-column>
                    <el-table-column prop="unitprice"
                                     label="Q/PRICE">
                    </el-table-column>
                  </el-table>
                  <span class="time_aniunt">
                    <div class="invoice_data">
                      <span>DATE:</span>
                      <span>{{time}}</span>
                    </div>
                    <div class="invoice_aniunt">
                      <span>AMOUNT:</span>
                      <span>{{amount[index]}} {{currencty[index]}}</span>
                    </div>
                  </span>
                </div>

                <div class="sheet_content_item_bottom">

                </div>
              </div>
            </li>
          </ul>
        </div>
        <el-button class='printBotton'
                   size="mini"
                   v-print="printObj">打印</el-button>
      </div>
      <!-- 拣货单 -->
      <div class="invoice_express_sheet pickingList"
           v-if="pickingList&&!manual">
        <div class="express_sheet_title pickingList_title">
          <h3>拣货单列表</h3>
          <p>*打印拣货单的时候请选择A4</p>
        </div>
        <div class="sheet_content pickingList_content">
          <!-- 拣货单内容 -->
          <ul class=" pickingList_express"
              id="printJS-form"
              ref='print'>
            <li class="express_sheet_content_item pickingList_item"
                style="page-break-after:always">
              <div class="print_area pickingList_print">
                <!-- 发票头部 -->
                <div class="sheet_content_item_top">
                  <div class="invoice_top pickingList_top">
                    <div class="invoice_title">待打包包裹明细(拣货单)</div>
                    <div class="sold_to">
                      <div class="sold_to_item">
                        <span>寄件人:</span>
                        <span>{{data.jjname}}</span>
                      </div>
                      <div class="sold_to_item">
                        <span>包裹数量:</span>
                        <span>{{data.bgnum}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <el-table :data="data.xz_weight_tj==''?[data]:pickingListData">
                  <el-table-column label="快递名"
                                   width="180">
                    <template>
                      {{data.kdname}}
                    </template>
                  </el-table-column>
                  <el-table-column label="单号"
                                   width="180">
                    <template slot-scope="scope">
                      {{data.xz_weight_tj==''?(data.kdnum==''?data.wlnum:data.kdnum):scope.row.zdnum}}
                    </template>
                  </el-table-column>
                  <el-table-column label="重量">
                    <template slot-scope="scope">
                      {{scope.row.weight}}KG
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </li>
          </ul>
        </div>
        <el-button class='printBotton'
                   size="mini"
                   v-print="printObj">打印</el-button>
      </div>

    </div>

  </el-main>
</template>

<script>
import { apiOrderDetails, apiSystemInfo } from '@/request/api'
import common from '@/assets/js/common'
export default {
  name: 'invoice',
  data () {
    return {
      // -------手动填写数据-------
      manualDate: {
        companynName: '',   //公司名
        masterNumber: '',    //主单号
        recipients: '',          //收件人姓名
        mobile: '',          //电话
        site: '',          //地址
        state: '',          //国家
        number: '',          //包裹数量
      },
      // -------手动填写显示框-------
      manualShow: false,
      manual: false,
      tuiheinfo: '',
      thtype: '',
      disabledReuter: true,
      showReturnGoods: false,
      active_state: '',
      pickingListData: [],
      newTableData: [[], []],
      currencty: [],
      amount: [],
      time: 0,
      loading: true,
      expressWaybill: true,
      invoice: false,
      pickingList: false,
      activeName: '1',
      tableData: [],
      orderId: '',
      data: {},
      currenctyDate: { '人民币': 'CNY', '美元': 'USD', '越南盾': 'VND', '新加坡元': 'MOP', '日元': 'JPY', '韩元': 'KRW', '马币': 'MYR', '台币': 'NTD', '港币': 'HKD', '欧元': 'EUR', '英镑': 'GBP', '法郎': 'FRF', '印度卢比': 'INR', '俄罗斯卢布': 'RUB', '澳大利亚元': 'AUD', '荷兰盾': 'NLG' },
      printObj: {
        id: "printJS-form",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      sonNumber: []
    }
  },
  methods: {
    //   ---------------生成面单数据---------------
    generateDate (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let res = {
            bgnum: this.manualDate.number,
            wlnum: this.manualDate.masterNumber,
            sjname: this.manualDate.recipients,
            sjmobile: this.manualDate.mobile,
            sjaddress: this.manualDate.site,
            sjprovince: this.manualDate.state,
            xz_weight_tj: ''
          }
          this.$set(this, 'data', res)
        } else {
          return false;
        }
      });
    },

    getPickingListData () {
      if (this.data.xz_weight_tj != '') {
        this.pickingListData = []
        for (const key in this.data.xz_weight_tj) {
          this.pickingListData.push(this.data.xz_weight_tj[key])
        }
      }
    },
    // 改变currencty
    getCurrencty (res, index) {
      this.$set(this.currencty, [parseInt(index) - 1], res)
    },
    // time
    getTime () {
      let data = Date.parse(new Date())
      let a = (new Date()).toLocaleDateString()
      a = a.replace(/\//g, '-');
      this.time = a
    },
    getAmount (i) {
      let price = 0
      for (const key in this.newTableData[i]) {
        price += parseFloat(this.newTableData[i][key].unitprice) * parseFloat(this.newTableData[i][key].num)
      }
      this.$set(this.amount, [i], price)
    },
    //浏览面单
    printExpressWaybill () {
      this.loading = true
      if (this.expressWaybill) {
      } else {
        this.invoice = false
        this.pickingList = false
        this.showReturnGoods = false
        this.expressWaybill = true
      }
      this.loading = false
    },
    //浏览发票
    printInvoice () {
      this.loading = true
      if (this.invoice) {
      } else {
        this.expressWaybill = false
        this.pickingList = false
        this.invoice = true
        this.showReturnGoods = false
      }
      this.loading = false
    },
    //浏览拣货单
    printPickingList () {
      this.loading = true
      if (this.pickingList) {
      } else {
        this.showReturnGoods = false
        this.expressWaybill = false
        this.invoice = false
        this.pickingList = true
      }
      this.loading = false
    },
    //浏览退货单
    printReturnGoods () {
      this.loading = true
      if (this.showReturnGoods) {
      } else {
        this.showReturnGoods = true
        this.expressWaybill = false
        this.pickingList = false
        this.invoice = false
      }
      this.loading = false
    },

    print (e) {
      this.$print(this.$refs.print)
    },

    test (item, id, p, w, h) {
      let width = w
      let height = h
      let res = ''
      let textPosition = p
      if (this.data.xz_weight_tj == '') {
        if (item == 1) {
          res = this.data.wlnum
        }
        else {
          res = this.data.wlnum + '-' + item
        }
      } else {
        if (this.data.xz_weight_tj[parseInt(item) - 1].zdnum) {
          if (item == 1) {
            res = this.data.wlnum
          } else {
            res = this.data.xz_weight_tj[parseInt(item) - 1].zdnum
          }
        } else {
          if (item == 1) {
            res = this.data.wlnum
          }
          else {
            res = this.data.wlnum + '-' + item
          }
        }
      }
      this.barcode(id + item, res, textPosition, width, height)
    },
    //转条形码
    barcode (id, code, position, w, h) {
      setTimeout(() => {
        var JsBarcode = require('jsbarcode')
        let barCode = code
        JsBarcode(id, barCode, {
          format: 'CODE128',//选择要使用的条形码类型
          text: barCode, //显示文本
          displayValue: true,//是否在条形码下方显示文字
          width: w && w != '' ? w + 'px' : '2px', //条宽度
          height: h && h != '' ? h + 'px' : '50px', //高度
          textPosition: position && position != '' ? position : 'bottom',//设置文本的垂直位置
          // fontOptions: “bold italic”,//使文字加粗体或变斜体
          // background: “#eee”,//设置条形码的背景
          font: 'Helvetica Neue',//设置文本的字体
          margin: 5//设置条形码周围的空白边距

        })
      }, 1);
    },
    //获取订单详情
    async getOrderDetails () {
      this.loading = true
      let res = await apiOrderDetails({
        op: 'orderinfo',
        pd: 'getinfo',
        orderid: this.orderId
      })
      this.data = res
      this.data.bgnum = parseInt(this.data.bgnum)
      let arr = []
      if (res.xz_weight_tj[0]) {
        for (let i = 0; i < this.data.bgnum; i++) {
          arr.push(res.xz_weight_tj[i].wpinfo)
        }
      }

      arr = JSON.stringify(arr)
      arr = JSON.parse(arr)
      this.tableData = arr
      // this.tableData = res.wpinfo
      this.sonNumber = common.transform(res.xz_weight_tj)
      this.getPickingListData()
      this.loading = false
    },
    //获取订单id
    getOrderId () {
      this.orderId = this.$route.query.id
    },

    //获取当前选中的物品
    tableSelect (s, r, i) {
      this.$set(this.newTableData, [i - 1], s)
      this.getAmount(parseFloat(i) - 1)
    },


  },
  created () {
    if (this.$route.query.manual == 1) {
      this.loading = false
      this.manualShow = true
      this.manual = true
    } else {
      if (this.$route.params.type == 'returnGoods') {
        this.disabledReuter = false
        this.tuiheinfo = this.$route.params.tuiheinfo
        this.thtype = this.$route.params.thtype
        this.loading = true
        if (this.showReturnGoods) {
        } else {
          this.showReturnGoods = true
          this.expressWaybill = false
          this.pickingList = false
          this.invoice = false
        }
        this.loading = false
      } else if (this.$route.query.type == 'pack') {
        this.active_state = this.$route.query.type
        this.expressWaybill = false
        this.loading = false
      } else {
        this.getOrderId()
        this.getOrderDetails()
        this.getTime()
      }
    }

  }



}
</script>

<style lang="scss">
@import "@/assets/css/variable.scss";
// @page {
//   size: auto !important; /* auto is the initial value */
//   margin: 0 !important; /* this affects the margin in the printer settings */
// }

.invoice {
  width: 100%;
  height: 100%;
  display: flex !important;
  .invoice_control {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .invoice_control_set {
      width: 80%;
      height: 70%;
      border-radius: 10px;
      background-color: $userColor;
      .el-collapse-item {
        background-color: $userColor;
        color: #ffffff;
        .el-collapse-item__content {
          display: flex;
          flex-direction: column;
          background-color: #fff;
          align-items: center;
          .invoice_control_set_goods {
            width: 90%;
            background-color: #fff;
            border: 0;
            height: 50px;
            .el-table__empty-block {
              background-color: #fff;
            }
            th {
              background-color: #fff;
              div {
                color: rgb(34, 33, 33);
                background-color: #fff;
              }
            }
            th,
            tr,
            td {
              border: 0;
              .el-input__inner {
                font-weight: 700;
                color: #1b1b1b;
                border: 0;
                padding-left: 0;
                background-color: transparent;
              }
              div {
                background-color: transparent !important;
                color: #1b1b1b;
                font-weight: 700;
              }
            }
            &::before {
              height: 0px;
            }
            &::after {
              width: 0;
            }

            .el-table__fixed:before {
              height: 0;
            }
            // border: #ccc dashed 1px;
            // margin-bottom: 10px;
          }
        }
        .el-collapse-item__header {
          color: #fff;
          padding-left: 10px;
          font-size: 16px;
          letter-spacing: 2px;
          font-weight: 700;
        }
        div {
          background-color: $userColor;
          color: #ffffff;
        }
      }
    }
    .invoice_control_button {
      overflow-x: auto;
      box-sizing: border-box;
      border-radius: 10px;
      display: flex;
      margin: 50px 0 20px 0;
      width: 80%;
      height: 100px;
      justify-content: center;
      align-items: center;
      background-color: $userColor;
      .el-button {
        width: 90px;
        display: flex;
        justify-content: center;
      }
    }
    .invoice_control_title {
      width: 80%;
      height: 200px;
      border-radius: 10px;
      background-color: $userColor;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: center;
      box-sizing: border-box;
      letter-spacing: 2px;
      padding-left: 50px;
    }
  }

  // 展示内容
  .invoice_show {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .invoice_express_sheet {
      position: relative;
      width: 120mm;
      .printBotton {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .express_sheet_title {
        height: 100px;
        background-color: #f56c6c;
        color: #ffffff;
        padding: 10px;
        box-sizing: border-box;
        letter-spacing: 2px;
      }
      p {
        letter-spacing: normal;
        margin-top: 10px;
      }
    }
  }
}
.sheet_content {
  display: flex;
  flex-direction: column;
  background-color: rgb(236, 236, 236);
  align-items: center;
}
.express_sheet_content {
  overflow: aotu;
  width: 112mm;
  // height: 80vh;
  // margin: 0 auto;
  // background-color: pink;
}
.express_sheet_content_item {
  margin-top: 10px;

  min-height: 100mm;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
}
.print_area {
  height: 100mm;
  width: 112mm;
  display: flex;
  flex-direction: column;

  align-items: center;
  .returnGoods_view {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    .returnGoods_title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 90%;
      height: 20%;
      font-size: 10mm;
      letter-spacing: 3mm;
      // background-color: pink;
      border-bottom: 1px solid #000;
    }
    .returnGoods_info {
      width: 90%;

      // height: 50%;
      // background-color: rgb(143, 143, 143);
      .returnGoods_info_item {
        margin-bottom: 10px;
      }
      .letts {
        .taxon_info {
          margin-right: 8mm;
        }
      }
    }
    .bar_code {
      padding-top: 10px;
      border-top: 1px solid #000;
      height: 20%;
      width: 100%;

      .content_item_code {
        width: 100%;
        height: 100%;
      }
    }
  }

  .sheet_content_item_top {
    display: flex;
    width: 100%;
    height: 25%;
    // background-color: pink;
    border-bottom: 1px solid #000;
    .invoice_top {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .invoice_title {
        font-size: 30px;
        font-weight: 700;
      }
      .sold_to {
        width: 100%;
        margin-top: 20px;
        font-weight: 700;
        span {
          margin-right: 50px;
        }
      }
    }
    .content_item_code {
      max-width: 200px !important;
    }
    .company_name {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-content: center;
      p {
        height: 100%;
        margin: 0;
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 30px;
        font-weight: 700;
        color: #333;
      }
    }
    .bar_code {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  .sheet_content_item_main {
    border-bottom: 1px solid #000;
    width: 100%;
    height: 30%;
    display: flex;
    font-weight: 700;
    font-size: 16px;
    flex-direction: column;
    justify-content: space-between;
    // flex-wrap: wrap;
    // .el-table td,
    // .el-table--group
    // .el-table--border,
    .el-table th.is-leaf {
      border-color: black;
    }
    .time_aniunt {
      width: 100%;
      height: 30px;
      display: flex;
      // justify-content: center;
      align-items: center;
      .invoice_data {
        width: 50%;
      }
      span {
        margin-right: 10px;
      }
    }
    .el-table__row tr {
      height: 30px;
    }
    tr {
      td {
        height: 30px;
        padding: 0;
        font-weight: normal;
      }
      th {
        .cell {
          color: #000;
        }
      }
    }
    .no {
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #000;
      span {
        margin-right: 50px;
      }
    }
    .recipients {
      width: 100%;
      display: flex;
      margin-top: 10px;
      .recipients_name {
        width: 50%;
      }
    }
    .issue {
      margin-right: 5px;
    }
    .site {
      width: 100%;
      white-space: normal;
    }
  }
  .invoice_main {
    height: auto;
  }
  .state_num {
    width: 100%;
    height: 15%;
    display: flex;
    border-bottom: 1px solid #000;
    .state,
    .parcel_number {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 30px;
    }
    .state {
      border-right: 1px solid #000;
    }
  }
  .sheet_content_item_bottom {
    height: 30%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .code_bottom {
      height: 100%;
      width: 100%;
      // margin-top: -10px;
      // background-color: pink;
    }
  }
}
.pickingList {
  margin-right: 30%;
  width: 210mm;
  .pickingList_title {
    background-color: #20a162 !important;
    width: 210mm;
  }
  .pickingList_content {
    width: 210mm;
  }
}

.pickingList_express {
  width: 100%;
  .pickingList_item {
    width: 100%;
    .pickingList_print {
      width: 100%;

      .el-table td,
      .el-table--group,
      .el-table--border,
      .el-table th.is-leaf {
        border-color: black;
      }
      .el-table {
        .has-gutter {
          width: 100%;
          .gutter {
            display: block !important;
          }
        }
        .el-table__body {
          width: 100% !important;
        }
        .el-table__header {
          width: 100% !important;
        }
      }
      .sold_to {
        display: flex;
        .sold_to_item {
          width: 50%;
        }
        span {
          margin-left: 10mm;
          font-size: 5mm;
        }
      }
    }
  }
}
</style>